import { OneEvent } from '../../common';
import { MODE } from '../../constants';

const LiveOneEvent = ({ id }) => <OneEvent id={id} serviceId={MODE.IN_PLAY} />;

export default LiveOneEvent;
